import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../services/redux/types";

export const selectDeerFlowState = (state: RootState) => state.deerFlowState;

export const selectDeerFlowInstances = createSelector(
  selectDeerFlowState,
  (state) => state.deerFlowInstances,
);

export const selectSelectedDeerFlowInstance = createSelector(
  selectDeerFlowState,
  (state) => state.selectedDeerFlowInstance,
);

export const selectSelectedInstanceAgent = createSelector(
  selectDeerFlowState,
  (state) => state.selectedInstanceAgent,
);

export const selectInstanceAgents = createSelector(
  selectDeerFlowState,
  (state) => state.instanceAgents,
);

export const selectSelectedInstanceThread = createSelector(
  selectDeerFlowState,
  (state) => state.selectedInstanceThread,
);

export const selectInstanceThreads = createSelector(
  selectDeerFlowState,
  (state) => state.instanceThreads,
);

export const selectInstanceThreadMessages = createSelector(
  selectDeerFlowState,
  (state) => state.messages,
);

export const selectDeerFlowMessageLoading = createSelector(
  selectDeerFlowState,
  (state) => state.isMessageLoading,
);
